
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-f46a47a4&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReviewHealth.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReviewHealth.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-f46a47a4!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReviewHealth.vue"),
  /* scopeId */
  "data-v-f46a47a4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/product-details/ReviewHealth.vue
// module id = 693
// module chunks = 2